import { FC } from 'react';

import { Link } from '@purpur/library';
import { Icon } from '@purpur/library/icon';
import { documentPdf } from '@purpur/library/icon/assets/document-pdf';
import Image from 'next/image';

import { IMAGES_PATH } from '@telialt/assets/src/constants';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useBrowserModalControls } from '@telialt/common-hooks/src/useBrowserModalControls';
import { ESHOP_TEST_ID } from '@telialt/core-eshop/src/test/test-ids';

import { DocumentLink, EnergyClassButton, FlexContainer } from './EnergyEfficiency.styles';
import { ImageModal } from './ImageModal';
import { EnergyEfficiencyType } from './model';

const ENERGY_EFFICIENCY_MODAL = 'energyEfficiencyModal';
type Props = EnergyEfficiencyType;

export const EnergyEfficiencyInfo: FC<Props> = ({
    energyClass,
    energyConsumingSupported,
    energyLabel,
    productInformationSheet,
}) => {
    const { t } = useTranslations();
    const { isModalOpen, openModal, closeModal } =
        useBrowserModalControls<EnergyEfficiencyType>(ENERGY_EFFICIENCY_MODAL);

    if (!energyConsumingSupported) {
        return null;
    }

    const energyClassIconPath = `${IMAGES_PATH}/energy-efficiency/icons/${energyClass}.svg`;
    const energyLabelURL = energyLabel?.url || '';
    const productInfoSheetURL = productInformationSheet?.url || '';

    return (
        <>
            <FlexContainer>
                <EnergyClassButton
                    role="button"
                    onClick={() => openModal()}
                    tabIndex={0}
                    data-test={ESHOP_TEST_ID.ENERGY_EFFICIENCY_CLASS}
                >
                    <Link variant="standalone">
                        <Image src={energyClassIconPath} alt=" " width="78" height="42" />
                    </Link>
                </EnergyClassButton>
                <DocumentLink data-test={ESHOP_TEST_ID.ENERGY_EFFICIENCY_DOCUMENT}>
                    <Link href={productInfoSheetURL} target="_blank" variant="text" disableVisited={true}>
                        <Icon svg={documentPdf} size="sm" />
                        {t['eshop.product.energy.info.sheet']}
                    </Link>
                </DocumentLink>
            </FlexContainer>
            <ImageModal isShown={isModalOpen} onHide={closeModal} imageUrl={energyLabelURL} />
        </>
    );
};
